import apolloBoost, { Operation } from 'apollo-boost';
import { ErrorResponse } from 'apollo-link-error';

import { config } from '../config';
import { authManager } from './auth';

// eslint-disable-next-line new-cap
const client = new apolloBoost({
  uri: `${config.API_ENDPOINT}/graphql`,
  request: async (operation: Operation): Promise<void> => {
    const token = authManager.getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
  onError: (error: ErrorResponse) => {
    const errors = error.response && error.response.errors;
    if (errors) {
      for (const { message } of errors) {
        if (message.match('Auth failed') || message.match('Not Authorized')) {
          client
            .clearStore()
            .then(() => {
              window.location.hash = `/auth?returnPath=${window.location.hash}`;
            })
            .catch(e => {
              console.error('Failed to clear store', e);
            });
        }
      }
    }
  },
});

export { client };



// WEBPACK FOOTER //
// ./src/services/api.ts